<template>
  <div>
    <div class="row q-gutter-x-sm">
      <div class="col">
        <q-list class="basic-info-list">
          <q-item v-if="palletArea" dense>
            <q-item-section>
              <q-item-label><span>{{ $t('palletArea') }}</span></q-item-label>
              <q-item-label>{{ palletArea | area(unitLabel('sqm'), userLocale) }}</q-item-label>
            </q-item-section>
          </q-item>
        </q-list>
      </div>
      <div class="col">
        <q-list class="basic-info-list">
          <q-item v-if="maxLength" dense>
            <q-item-section>
              <q-item-label><span>{{ $t('maxLength') }}</span></q-item-label>
              <q-item-label>{{ maxLength | numberWithUnit('cm', userLocale) }}</q-item-label>
            </q-item-section>
          </q-item>
        </q-list>
      </div>
    </div>

    <q-slide-transition>
      <div v-if="!collapsed">
        <div class="row q-gutter-x-sm">
          <div class="col">
            <q-list class="basic-info-list">
              <q-item v-if="place && user && !simplified" dense>
                <q-item-section>
                  <q-item-label><span>{{ $t('place') }}</span></q-item-label>
                  <q-item-label>{{ place }}</q-item-label>
                </q-item-section>
              </q-item>
              <q-item v-if="resultAreaNotRemeasured" dense>
                <q-item-section>
                  <q-item-label><span>{{ $t('packageArea') }}</span></q-item-label>
                  <q-item-label>{{ resultAreaNotRemeasured | area(unitLabel('sqm'), userLocale) }}</q-item-label>
                </q-item-section>
              </q-item>
              <q-item v-if="resultAreaNotRemeasured && palletArea" dense>
                <q-item-section>
                  <q-item-label><span>{{ $t('inPalletPercentage') }}</span></q-item-label>
                  <q-item-label>{{ (resultAreaNotRemeasured / palletArea) * 100 | numberWithUnit(unitLabel('percentage'), userLocale, 0, 0) }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </div>
          <div class="col">
            <q-list class="basic-info-list">
              <q-item v-if="bundleCount" dense>
                <q-item-section>
                  <q-item-label><span>{{ $t('bundleCount') }}</span></q-item-label>
                  <q-item-label>{{ bundleCount }}</q-item-label>
                </q-item-section>
              </q-item>
              <q-item v-if="resultAreaMeasuredBack" dense>
                <q-item-section>
                  <q-item-label><span>{{ $t('measuredArea') }} ({{ $t('unit.sqm') }})</span></q-item-label>
                  <q-item-label>{{ resultAreaMeasuredBack | area(unitLabel('sqm'), userLocale) }}</q-item-label>
                </q-item-section>
              </q-item>
              <q-item v-if="resultAreaMeasuredBack && resultAreaNotRemeasured" dense>
                <q-item-section>
                  <q-item-label><span>{{ $t('measuredArea') }} ({{ $t('unit.percentage') }})</span></q-item-label>
                  <q-item-label>{{ (resultAreaMeasuredBack / resultAreaNotRemeasured) * 100 | numberWithUnit(unitLabel('percentage'), userLocale, 0, 0) }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </div>
        </div>

        <template v-if="user && !simplified">
          <q-separator spaced/>
          <div class="extended-info-list q-pt-sm">
            <q-list class="basic-info-list">
              <q-item v-if="palletInfo">
                <q-item-section>
                  <q-item-label><span>{{ $t('palletInfo') }}</span></q-item-label>
                  <q-item-label>{{ palletInfo }}</q-item-label>
                </q-item-section>
              </q-item>
              <q-item v-if="palletInfoInternal">
                <q-item-section>
                  <q-item-label><span>{{ $t('palletInfoInternal') }}</span></q-item-label>
                  <q-item-label>{{ palletInfoInternal }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </div>
        </template>
      </div>
    </q-slide-transition>

    <q-btn flat color="primary" class="card-collapse-button" @click="collapsed = !collapsed" :icon="collapsed ? 'add' : 'remove'"
           :label="collapsed ? $t('more') : $t('less')" padding="4px 4px 4px 0" no-caps/>
  </div>
</template>

<script>
import NumberFormattingFilters from "@/mixins/NumberFormattingFilters";
import LogPropertiesResolver from "@/mixins/LogPropertiesResolver";
import {mapGetters} from "vuex";

export default {
  name: "PalletInfo",
  mixins: [LogPropertiesResolver, NumberFormattingFilters],
  props: {
    pallet: Object,
    isPublic: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      collapsed: true
    }
  },
  computed: {
    ...mapGetters(['user', 'watchlist']),
    simplified() {
      //return this.watchlist && this.isPublic ? this.watchlist.simplified : false;
      return false;
    },
    fillLastRow() {
      let items = 0;

      if (this.palletArea) items++;
      if (this.resultAreaNotRemeasured) items++;
      if (this.resultAreaNotRemeasured && this.palletArea) items++;
      if (this.resultAreaMeasuredBack) items++;
      if (this.resultAreaMeasuredBack && this.resultAreaNotRemeasured) items++;
      if (this.maxLength) items++;
      if (this.bundleCount) items++;
      if (this.place && this.user && !this.simplified) items++;

      return items % 2 === 1;
    }
  },
}
</script>

<style scoped>

</style>